import { gql } from 'graphql.macro';

export const millingMaterialFragment = gql`
    fragment millingMaterialFields on MillingMaterial {
        _id
        additionalColors
        name
        useVitaColors
    }
`;

export const millingJobTypesFragment = gql`
    fragment millingJobTypesFields on MillingJobType {
        _id
        materials {
            ...millingMaterialFields
        }
        name
    }
    ${millingMaterialFragment}
`;

export const millingJobFragment = gql`
    fragment millingJobFields on MillingJob {
        _id
        jobType
        material
        color
        createdAt
        createdBy {
            _id
            fullName
            name {
                firstName
                lastName
            }
        }
        status
        filename
        zipFileKey
        stlFiles {
            url
            filename
        }
        copyReason
        deadline
        comment
    }
`;

export const millingBatchFragment = gql`
    fragment millingBatchFields on MillingBatch {
        _id
        jobType
        material
        color
        status
        createdAt
        batchNumber
        zipFileKey
        createdBy {
            _id
            name {
                firstName
                lastName
            }
            fullName
        }
        orders {
            _id
            orderId
        }
        millingJobs {
            ...millingJobFields
            order {
                _id
                orderId
                internalOrderId
                workFlow {
                    currentStep {
                        _id
                        name
                    }
                }
            }
        }
    }
    ${millingJobFragment}
`;
